<div class="detail-container">
  <nb-card [nbSpinner]="!!(saving$|async)">
    <nb-card-header>
      <button nbButton ghost status="primary" (click)="navigateBack()">
        <nb-icon pack="eva" icon="arrow-back-outline"></nb-icon>
      </button>
      <h5>Wohnung</h5>
      @if (canEdit() && !isNew()) {
        <wr-edit-delete-button-group (edit)="onEdit()" (delete)="onDelete()"></wr-edit-delete-button-group>
      }
    </nb-card-header>
    <nb-card-body>
      @if (form) {
        <nb-tabset>
          <nb-tab tabTitle="Basisdaten">
            <hau-form [formGroup]="form" class="tab-form">
              <hau-form-field label="Nummer" [validation]="form.validation.flatNumber" cols="2">
                <input nbInput fullWidth formControlName="flatNumber" type="number" min="0" step="1">
              </hau-form-field>
              <hau-form-field label="Fläche" [validation]="form.validation.size" cols="2">
                <wr-area-input formControlName="size"></wr-area-input>
              </hau-form-field>
              <hau-form-field label="Etage" [validation]="form.validation.floor" cols="2">
                <input nbInput fullWidth formControlName="floor" type="number" step="1">
              </hau-form-field>
              <hau-form-field label="Tür" [validation]="form.validation.doorNumber" cols="2">
                <input nbInput fullWidth formControlName="doorNumber" type="text">
              </hau-form-field>
              <hau-form-field label="Gebäude Teil" [validation]="form.validation.buildingSectionId" cols="3">
                <wr-building-section-select-form-control formControlName="buildingSectionId"
                                                         [buildingSections]="buildingSections()">
                </wr-building-section-select-form-control>
              </hau-form-field>
              <hau-form-field label="Farbe" [validation]="form.validation.color" cols="6">
                <wr-color-preset-picker formControlName="color"></wr-color-preset-picker>
              </hau-form-field>
            </hau-form>
          </nb-tab>

          <nb-tab tabTitle="Sensorinstallationen">
            <hau-form [formGroup]="form" class="tab-form">
              <hau-form-field label="Heizung Sensor" [validation]="form.validation.heatSensor" cols="4">
                <wr-sensor-installation-select
                  formControlName="heatSensor"
                  [buildingId]="buildingId()!"
                  [dimension]="heatDimension"
                  [purposes]="unitMeterPurposes">
                </wr-sensor-installation-select>
                @if (form.value.heatSensor && form.value.heatSensor.isActive === false) {
                  <wr-banner [icon]="{ icon: 'alert-triangle-outline', pack: 'eva' }"
                             status="warning"
                             message="Dieser Sensor ist deaktiviert und wird in der Wohnungsabrechnung nicht verwendet.">
                  </wr-banner>
                }
                @if (form.value.heatSensor && form.value.heatSensor.purpose !== unitMeterPurpose) {
                  <wr-banner [icon]="{ icon: 'alert-triangle-outline', pack: 'eva' }"
                             status="warning"
                             message="Dieser Sensor ist nicht als Wohnungszähler klassifiziert. Verwendung am Sensor prüfen.">
                  </wr-banner>
                }
              </hau-form-field>
              <hau-form-field label="Warmwasser Sensor" [validation]="form.validation.hotWaterSensor" cols="4">
                <wr-sensor-installation-select
                  formControlName="hotWaterSensor"
                  [buildingId]="buildingId()!"
                  [dimension]="hotWaterDimension"
                  [purposes]="unitMeterPurposes">
                </wr-sensor-installation-select>
                @if (form.value.hotWaterSensor && form.value.hotWaterSensor.isActive === false) {
                  <wr-banner [icon]="{ icon: 'alert-triangle-outline', pack: 'eva' }"
                             status="warning"
                             message="Dieser Sensor ist deaktiviert und wird in der Wohnungsabrechnung nicht verwendet.">
                  </wr-banner>
                }
                @if (form.value.hotWaterSensor && form.value.hotWaterSensor.purpose !== unitMeterPurpose) {
                  <wr-banner [icon]="{ icon: 'alert-triangle-outline', pack: 'eva' }"
                             status="warning"
                             message="Dieser Sensor ist nicht als Wohnungszähler klassifiziert. Verwendung am Sensor prüfen.">
                  </wr-banner>
                }
              </hau-form-field>
              <hau-form-field label="TGA" [validation]="form.validation.buildingEquipmentId" cols="4">
                <wr-building-equipment-select formControlName="buildingEquipmentId"
                                              [buildingEquipments]="buildingEquipments()">
                </wr-building-equipment-select>
              </hau-form-field>
            </hau-form>
          </nb-tab>

          @if (!isNew()) {
            <nb-tab tabTitle="Bewohner">
              <div class="residents-container">
                @if ((residents()?.length ?? 0) > 0) {
                  <table class="residents-table">
                    <thead>
                      <tr>
                        <th>Kundennummer</th>
                        <th>Einzug</th>
                        <th>Auszug</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (resident of residents() || []; track resident.id) {
                        <tr>
                          <td>{{ resident.customerNumber }}</td>
                          <td>{{ resident.startDate | date:'dd.MM.yyyy' }}</td>
                          <td>
                            @if (resident.endDate) {
                              <span>{{ resident.endDate | date:'dd.MM.yyyy' }}</span>
                            }
                            @if (!resident.endDate) {
                              <nb-tag text="Aktuell" status="success" [removable]="false"></nb-tag>
                            }
                          </td>
                          <td class="actions-cell">
                            @if (!resident.endDate) {
                              <button nbButton ghost status="warning"
                                      (click)="checkoutResident(resident)"
                                      nbTooltip="Auszug erfassen">
                                <nb-icon pack="eva" icon="log-out-outline"></nb-icon>
                              </button>
                            }
                            <button nbButton ghost status="primary"
                                    (click)="editResident(resident)"
                                    nbTooltip="Bearbeiten">
                              <nb-icon pack="eva" icon="edit-2-outline"></nb-icon>
                            </button>
                            <button nbButton ghost status="danger"
                                    (click)="removeResident(resident)"
                                    nbTooltip="Entfernen">
                              <nb-icon pack="eva" icon="trash-2-outline"></nb-icon>
                            </button>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                }

                @if ((residents()?.length ?? 0) === 0) {
                  <div class="empty-residents">
                    <nb-icon pack="eva" icon="people-outline"></nb-icon>
                    <p>Keine Bewohner eingetragen</p>
                  </div>
                }

                <div class="residents-footer">
                  <button nbButton status="primary" size="small" (click)="addResident()">
                    <nb-icon pack="eva" icon="plus-outline"></nb-icon>
                    Bewohner hinzufügen
                  </button>
                </div>
              </div>
            </nb-tab>
          }
        </nb-tabset>
      }
    </nb-card-body>
    @if (canEdit()) {
      <nb-card-footer>
        <button size="medium" [disabled]="!isEditing" nbButton status="primary" (click)="submit()">Speichern</button>
        <button size="medium" [disabled]="!isEditing" nbButton status="basic" (click)="cancel()">Zurück</button>
      </nb-card-footer>
    }
  </nb-card>
</div>
